// Full fixed code with improved flow control for Add and Find Contact

import React, { useCallback, useEffect, useRef, useState } from "react";
import "./GenericChatbotContainer.css";
import iq_api_v2 from "../../../../services/iqApiV2";
import { useParams } from "react-router-dom";
import { useUser } from "../../../../context/UserContext";
import { useDispatch, useSelector } from "react-redux";
import { fetchOpportunitiesRequest } from "../../../../store/features/actions/opportunities/opportunitesActions";
import { fetchWinOpportunitiesRequest } from "../../../../store/features/actions/opportunities/winOpportunitiesActions";
import IOSSpinner from "../../../HtmlElements/IOSSpinner";
import SelectDropDownComp from "./selectDropDownComp";
import { FetchSpotContactsRequest } from "../../../../store/features/actions/targetedReachout/spotContactsActions";





const AddContactForm = ({ findConData, setFindConData,pushMessage }) => {
  const { spotContactsData } = useSelector((state) => state?.spotContactsReducer);
  const [selectedContact, setSelectedContact] = useState(null);
  const [selectedOpp, setSelectedOpp] = useState(null);

  const handleApplyForFind = useCallback(() => {
    setFindConData({ selectedContact, selectedOpp });
    pushMessage("SalesPlay", <>Please provide custom instructions to proceed</>);
  }, [selectedContact, selectedOpp, setFindConData]);

  return (
    <div>
      <div className="chatbot-add-container">
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <span className="chatbot-form-text-titl">Please select a contact</span>
          <span className="chatbot-form-text-titl" style={{ cursor: "pointer" }} onClick={() => { setSelectedContact(null); setSelectedOpp(null); }}>
            clear
          </span>
        </div>
        <SelectDropDownComp
          allOptions={spotContactsData || []}
          selectedValues={selectedContact}
          setSelectedValues={(val) => { setSelectedContact(val); setSelectedOpp(null); }}
          onApply={() => {}}
          multiSelect={false}
          valueKey="contact_id"
          labelKey="contact_name"
        />
      </div>

      <div className="chatbot-add-container">
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <span className="chatbot-form-text-titl">
            {!selectedContact ? "Select a Contact to proceed" : "Please select an opportunity"}
          </span>
          <span className="chatbot-form-text-titl" style={{ cursor: "pointer" }} onClick={() => setSelectedOpp(null)}>
            clear
          </span>
        </div>
        <SelectDropDownComp
          allOptions={selectedContact?.opportunities || []}
          selectedValues={selectedOpp}
          setSelectedValues={setSelectedOpp}
          onApply={handleApplyForFind}
          disableFooter={!selectedOpp}
          multiSelect={false}
          valueKey="id"
          labelKey="name"
        />
      </div>
    </div>
  );
};

const ChatContainerForContact = ({ onBack, type }) => {
  const dispatch = useDispatch();
  const { clientName, accountName } = useParams();
  const { user } = useUser();

  const [message, setMessage] = useState("");
  const [chatMessages, setChatMessages] = useState([]);
  const [flowType, setFlowType] = useState("");
  const [oppData, setOppData] = useState({});
  const [findConData, setFindConData] = useState(null);

  const textareaRef = useRef(null);
  const containerRef = useRef(null);




const resetAllStates = () => {
  setMessage("");
  setFlowType("");
  setOppData({});
  setFindConData(null);
};

// Handler to push the "Find/Add Another" prompt
const pushRestartPrompt = () => {
  pushMessage("SalesPlay", (
    <div className="find-opp-catagory-container">
      <span>Would you like to find/add a reach out for another contact?</span>
      <button className="find-opp-catagory-container-btn" onClick={handleRestartFlow}>Yes</button>
      <button className="find-opp-catagory-container-btn" onClick={()=>{resetAllStates();onBack()}}>No</button>
    </div>
  ));
};

const handleRestartFlow = () => {
  resetAllStates();
  // Show the initial options
  pushMessage("SalesPlay", (
    <div className="find-opp-catagory-container">
      <button className="find-opp-catagory-container-btn" onClick={() => handleAPIAddOpp("Find Contact")}>Find Contact</button>
      <button className="find-opp-catagory-container-btn" onClick={() => handleAPIAddOpp("Add Contact")}>Add Contact</button>
    </div>
  ));
};


  useEffect(() => {
    if (type === "spot") {
      setChatMessages([
        { sender: "SalesPlay", message: `Hi ${user?.firstname}! 👋 Do you want to add a contact or select contact`, timestamp: getTime() },
        {
          sender: "SalesPlay",
          message: (
            <div className="find-opp-catagory-container">
              <button className="find-opp-catagory-container-btn" onClick={() => handleAPIAddOpp("Find Contact")}>Find Contact</button>
              <button className="find-opp-catagory-container-btn" onClick={() => handleAPIAddOpp("Add Contact")}>Add Contact</button>
            </div>
          ),
          timestamp: getTime(),
        },
      ]);
    }
  }, [type, user?.firstname]);

  const getTime = () => new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });

  const pushMessage = (sender, message, isLoading = false) => {
    setChatMessages((prev) => [...prev, { sender, message, isLoading, timestamp: !isLoading ? getTime() : undefined }]);
  };

  const updateLastMessage = (message) => {
    setChatMessages((prev) => {
      const updated = [...prev];
      updated[updated.length - 1] = { ...updated[updated.length - 1], message, isLoading: false, timestamp: getTime() };
      return updated;
    });
  };

  const handlePostSuccess = (response) => {
    const nextPrompt = response?.data?.next_prompt || `Thanks. You’ll see it inside ${type} Opportunities in 1–2 minutes.`;
    const shouldFetch = response?.data?.task_id === 1;

    updateLastMessage(nextPrompt);

    if (shouldFetch) {
      const action = type === "spot" ? fetchOpportunitiesRequest : fetchWinOpportunitiesRequest;
      dispatch(action({ clientName, accountName, userId: user?.id, type }));
    }
  };

  const handleAPIAddOpp = async (input) => {
    if (!input.trim()) return;
    setMessage("");
    pushMessage(user?.firstname || "User", input);

    if (input === "Add Contact") {
      setFlowType("add");
      setOppData({});
      setFindConData(null);
      pushMessage("SalesPlay", <>Please Give a Contact Name</>);
      return;
    }

    if (input === "Find Contact") {
      setFlowType("find");
      setOppData({});
      setFindConData(null);
      pushMessage("SalesPlay", <>Searching Contacts...</>);
      pushMessage("SalesPlay", <AddContactForm findConData={findConData} setFindConData={setFindConData} pushMessage={pushMessage}/>);
      return;
    }

    if (flowType === "add") {
      const { contact_name, opportunity_name, opportunity_description, custom_instructions } = oppData;

      if (!contact_name) {
        setOppData((prev) => ({ ...prev, contact_name: input }));
        pushMessage("SalesPlay", <>Please Give Opportunity Name</>);
        return;
      }
      if (!opportunity_name) {
        setOppData((prev) => ({ ...prev, opportunity_name: input }));
        pushMessage("SalesPlay", <>Please Give Opportunity Description</>);
        return;
      }
      if (!opportunity_description) {
        setOppData((prev) => ({ ...prev, opportunity_description: input }));
        pushMessage("SalesPlay", <>Please Provide Some Instructions</>);
        return;
      }
      if (!custom_instructions) {
        setOppData((prev) => ({ ...prev, custom_instructions: input }));
        pushMessage("SalesPlay", null, true);
      }

      try {
        const data = {
          client: clientName,
          account: accountName,
          contact_name,
          opportunity_name,
          opportunity_description,
          funnel_stage: "first meeting",
          custom_instructions: custom_instructions || input,
        };
        const response = await iq_api_v2.post("touch_nurture_sequence", {}, { params: data });
        handlePostSuccess(response);
        updateLastMessage("Reach out kit will be created shortly");
        resetAllStates();
        pushRestartPrompt();
      } catch (err) {
        updateLastMessage(`❗ ${err?.response?.data?.message || "Something went wrong"}`);
      }
      return;
    }

    if (flowType === "find" && findConData?.selectedContact?.contact_id && findConData?.selectedOpp?.id && !oppData.custom_instructions) {
      setOppData({
        contact_name: findConData.selectedContact.contact_name,
        opportunity_name: findConData.selectedOpp.name,
        opportunity_description: findConData.selectedOpp.description,
        custom_instructions: input,
      });

      pushMessage("SalesPlay", null, true);
      try {
        const data = {
          client: clientName,
          account: accountName,
          contact_name: findConData.selectedContact.contact_name,
          opportunity_name: findConData.selectedOpp.name,
          opportunity_description: findConData.selectedOpp.description,
          funnel_stage: "first meeting",
          custom_instructions: input,
        };
        const response = await iq_api_v2.post("touch_nurture_sequence", {}, { params: data });
        if (response) {
          setChatMessages((prev) => {
            const updated = [...prev];
            if (updated.length > 0 && updated[updated.length - 1].isLoading) updated.pop();
            return updated;
          });
          pushMessage("SalesPlay", <>Finding and creating Reach out kit shortly</>);
          resetAllStates();
          pushRestartPrompt();
        }
      } catch (err) {
        updateLastMessage(`❗ ${err?.response?.data?.message || "Something went wrong"}`);
      }
    }
  };

  const renderMessages = (messages) =>
    messages.map((msg, index) => {
      const isUser = msg.sender === user?.firstname;
      const prevSender = index > 0 ? messages[index - 1].sender : null;
      const showSender = msg.sender !== prevSender;
      return (
        <div key={index} className={`message-wrapper ${isUser ? "align-right" : "align-left"}`}>
          {showSender && <p className="sender-name">{msg.sender}</p>}
          <div className={`message-bubble-${isUser ? "User" : msg.sender} ${msg.isLoading ? "is-loading" : ""}`}>
            <div className="message-content">{msg.message}</div>
            {!msg.isLoading && msg.timestamp && (
              <div className={`message-timestamp-${isUser ? "User" : msg.sender}`}>{msg.timestamp}</div>
            )}
          </div>
        </div>
      );
    });

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  }, [message]);

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollTop = containerRef.current.scrollHeight;
    }
  }, [chatMessages]);

  return (
    <div className="chatbox-container">
      <div className="chatbox-header" onClick={onBack}>
        <img className="back-btn-img" src="/img/back_top.png" />
        <span className="back_chat_top">Back</span>
      </div>

      <div className="chatbox-messages-container" ref={containerRef}>
        {renderMessages(chatMessages)}
      </div>

      <div className="chatbox-input-container">
        <textarea
          ref={textareaRef}
          className="chatbox-input"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          placeholder="Describe your opportunity"
        />
        <button className="send-button" onClick={() => handleAPIAddOpp(message)}>
          <img className="send-button-img" src="/img/arrow-up.png" />
        </button>
      </div>
    </div>
  );
};

export default ChatContainerForContact;